import { StateCreator } from 'zustand'

export interface UserLot {
  auctionId?: string
  bidAmount?: number
  bidId?: string
  hasActiveBid: boolean
  invoiceId?: number
  lotUniqueId: string
  paddleNo?: number
  won: boolean
}

export interface UserState {
  user: { lots: Record<string, UserLot> }
}

export interface UserActions {
  addLot: (lot: UserLot) => void
  clearLots: () => void
  createLots: (lots: Record<string, UserLot>) => void
  removeLot: (lotUniqueId: UserLot['lotUniqueId']) => void
  updateLot: (
    lotUniqueId: UserLot['lotUniqueId'],
    lot: Partial<UserLot>
  ) => void
}

export type UserSlice = UserState & UserActions

export const initialUserState = { user: { lots: {} } }

export const createUserSlice: StateCreator<UserSlice> = (set) => ({
  ...initialUserState,
  addLot: (lot) =>
    set((state) => ({
      user: {
        ...state.user,
        lots: { ...state.user.lots, [lot.lotUniqueId]: lot },
      },
    })),
  clearLots: () =>
    set(() => ({
      ...initialUserState,
    })),
  createLots: (lots) =>
    set((state) => ({
      user: {
        ...state.user,
        lots: { ...state.user.lots, ...lots },
      },
    })),
  removeLot: (lotUniqueId) =>
    set((state) => {
      const lots = structuredClone(state.user.lots)
      delete lots[lotUniqueId]
      return { user: { ...state.user, lots } }
    }),
  updateLot: (lotUniqueId, lot) =>
    set((state) => {
      if (!state.user.lots[lotUniqueId]) {
        return state
      }

      const lots = structuredClone(state.user.lots)
      lots[lotUniqueId] = {
        ...state.user.lots[lotUniqueId],
        ...lot,
      }
      return { user: { ...state.user, lots } }
    }),
})
